import * as moment from 'moment';

import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { publish } from '@holmescorp/pub-sub';
import { Keys } from '@holmescorp/common';
import { createNlsMiddleware } from '@holmescorp/lcc-state';

import css from '../css/progress-tracker.m.css';

interface PTExamDateProperties {
	examdate: any;
}

const settingsNls = createNlsMiddleware('settings');
const factory = create({
	theme,
	settingsNls
}).properties<PTExamDateProperties>();

export const PTExamDate = factory(({ properties, middleware: { theme, settingsNls } }) => {
	const themeCss = theme.classes(css);

	const { examdate } = properties();

	const {
		messages: {
			examcountdown_date = '[settings] examcountdown_date',
			examset_date = '[settings] examset_date',
			include_exam_countdown = 'false'
		}
	} = settingsNls();

	const hide_exam_countdown = v('div', { classes: [themeCss.ptExamDate] });

	const examset_text = v(
		'div',
		{
			classes: [themeCss.ptExamDate],
			onclick: () => publish('settings/open'),
			onkeydown: (event) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						publish('settings/open');
				}
			}
		},
		[v('span', { classes: themeCss.setExamDate }, [examset_date])]
	);

	const examcountdown_text = v('div', { classes: [themeCss.ptExamDate] }, [
		v('span', { classes: themeCss.examDate }, [examcountdown_date]),
		v('span', {}, [moment(examdate).format('l')])
	]);

	return include_exam_countdown === 'false' ? hide_exam_countdown : examdate ? examcountdown_text : examset_text;
});

export default PTExamDate;
